// src/Services/AnalyticsService.js
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries';

const client = generateClient();

class AnalyticsService {
  async fetchData(timeRange, options = {}) {
    try {
      console.log('Fetching trucks with options:', options);

      const trucksResponse = await client.graphql({
        query: queries.listTrucks,
        variables: { 
          limit: 1000 
        }
      });

      console.log('Trucks Response:', trucksResponse);

      // Check for errors in the response
      if (trucksResponse.errors) {
        console.error('GraphQL Errors:', trucksResponse.errors);
        throw new Error(trucksResponse.errors.map(e => e.message).join('; '));
      }

      const techniciansResponse = await client.graphql({
        query: queries.listTechnicians
      });

      console.log('Technicians Response:', techniciansResponse);

      // Check for errors in the technicians response
      if (techniciansResponse.errors) {
        console.error('GraphQL Technicians Errors:', techniciansResponse.errors);
        throw new Error(techniciansResponse.errors.map(e => e.message).join('; '));
      }

      return {
        trucks: trucksResponse.data.listTrucks.items,
        technicians: techniciansResponse.data.listTechnicians.items
      };
    } catch (error) {
      console.error('Complete Error Object:', error);
      console.error('Error fetching data:', error.message);
      
      // More detailed error handling
      if (error.errors) {
        error.errors.forEach(err => {
          console.error('Specific Error:', err);
        });
      }

      throw error;
    }
  }
}

export default new AnalyticsService();